import { useEffect, useState } from 'react';

import { Modal, TextField } from '@atom/mui';

import { validateFolderName } from './filesTabUtilities';

type CreateMediaFolderModalProps = {
  open: boolean;
  parentFolderId: string;
  onCreate: (parentFolderId: string, name: string) => void;
  closeModal: () => void;
};

const DEFAULT_NAME = 'Untitled';

const CreateMediaFolderModal = ({
  open,
  parentFolderId,
  onCreate,
  closeModal,
}: CreateMediaFolderModalProps) => {
  const [name, setName] = useState<string>(DEFAULT_NAME);

  useEffect(() => {
    if (open) {
      setName(DEFAULT_NAME);
    }
  }, [open]);

  const errorText = validateFolderName(name);

  const handleConfirm = () => {
    onCreate(parentFolderId, name);
    closeModal();
  };

  return (
    <Modal
      open={open}
      title="Create Folder"
      confirmButtonText="Save"
      onConfirm={handleConfirm}
      onCancel={closeModal}
      disabled={errorText.length > 0}
      CancelButtonProps={{ 'data-cy': 'filesTabCreateFolderCancel' }}
      ConfirmButtonProps={{ 'data-cy': 'filesTabCreateFolderConfirm' }}
    >
      <TextField
        label="Folder Name"
        name="name"
        value={name}
        autoFocus
        error={errorText.length > 0}
        helperText={errorText}
        onChange={event => setName(event.target.value)}
        data-cy="filesTabCreateFolderNameInput"
      />
    </Modal>
  );
};

export default CreateMediaFolderModal;
